export default __webpack_public_path__ + "static/media/2.95edcd15.png";